import React from "react";
import { of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { getTokensObservable } from "../../utils/authn";
import useStreamedElement from "../../utils/reactive/useStreamedElement";
import BannerListItem from "../BannerListItem";

const tokens$ = getTokensObservable();

export default function SessionExpiredAlert(props) {
  return useStreamedElement(() => {
    return tokens$.pipe(
      map(() => null),
      catchError(() =>
        of(
          <BannerListItem error>
            Something has gone wrong. Please refresh the page and sign in again.
          </BannerListItem>
        )
      )
    );
  }, props);
}
